import Cookies from 'js-cookie'

export const getAuthHeaders = () => {
  const localStore = localStorage.getItem('dindin_key')
  const authToken = Cookies.get('authtoken') || localStore
  return authToken ? { Authorization: `Token ${authToken}` } : {}
}
